import { useState, useCallback, useEffect } from "react";

const useMenu = () => {
  const [menuIndex, setMenuIndex] = useState(null);
  const [activeItem, activateItem] = useState(null);
  const [activeCategories, setActiveCategories] = useState([]);

  const activateCategory = useCallback((code) => {
    setActiveCategories(activeCategories.concat([code]));
  }, [activeCategories]);

  const deactivateCategory = useCallback((code) => {
    setActiveCategories(activeCategories.filter((d) => d !== code));
  }, [activeCategories]);

  const activeCheck = useCallback((code, type) => {
    if (type === "item") {
      return code && (code === activeItem);
    }
    if (type === "category") {
      return activeCategories.some((activeCategory) => code === activeCategory);
    }
    return activeCheck(code, "item") || activeCheck(code, "category");
  }, [activeItem, activeCategories]);

  const activateParentCategory = useCallback((itemCode) => {
    if (!itemCode) {
      return;
    }
    const categoryCode = itemCode.split("_").slice(0, -1).join("_");
    activateCategory(categoryCode);
  }, [activeCategories]);

  const initialize = (index, code) => {
    setMenuIndex(index);
    setActiveCategories([]);
    activateItem(code);
    activateParentCategory(code);
  };

  // Itemをactivateした際に、親であるCategoryもactivateする
  useEffect(() => {
    activateParentCategory(activeItem);
  }, [activeItem]);
  return { menuIndex, initialize, activeCheck, activateItem, activateCategory, deactivateCategory };
};

export default useMenu;